(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('num-reference-contrat', {
            parent: 'entity',
            url: '/num-reference-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'wamasysApp.numReferenceContrat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrats.html',
                    controller: 'NumReferenceContratController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('numReferenceContrat');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('num-reference-contrat-detail', {
            parent: 'entity',
            url: '/num-reference-contrat/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'wamasysApp.numReferenceContrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-detail.html',
                    controller: 'NumReferenceContratDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('numReferenceContrat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NumReferenceContrat', function($stateParams, NumReferenceContrat) {
                    return NumReferenceContrat.get({id : $stateParams.id});
                }]
            }
        })
        .state('num-reference-contrat.new', {
            parent: 'num-reference-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-dialog.html',
                    controller: 'NumReferenceContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroActuel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('num-reference-contrat');
                });
            }]
        })
        .state('num-reference-contrat.edit', {
            parent: 'num-reference-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-dialog.html',
                    controller: 'NumReferenceContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NumReferenceContrat', function(NumReferenceContrat) {
                            return NumReferenceContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('num-reference-contrat.delete', {
            parent: 'num-reference-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-delete-dialog.html',
                    controller: 'NumReferenceContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NumReferenceContrat', function(NumReferenceContrat) {
                            return NumReferenceContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
